import { call, all } from 'redux-saga/effects';
import { onFetchSampleQueries } from './fetchSamples';
import { onFetchAiResponse } from './getAiResponse';

export default function* aiSaga() {
  yield all([
    call(onFetchSampleQueries),
    call(onFetchAiResponse)
  ]);
}
